// extracted by mini-css-extract-plugin
export default {"btn":"MoreButton_btn__zULCG"};